export const applyClickjackProtection = () => {
  if (window.top && window.self === window.top) {
    document.documentElement.style.display = 'block'
  } else {
    if (window.top) {
      window.top.location = window.self.location
    }
  }

  if (window.navigator.userAgent.match(/(msie|trident)/i)) {
    const unsupportedMsg = document.getElementById('unsupportedBrowserMsg')
    const appRoot = document.getElementById('subapp-container') ?? document.getElementById('root')

    if (unsupportedMsg) unsupportedMsg.style.display = 'block'
    if (appRoot) appRoot.style.display = 'none'
  }
}
